<template>
    <div v-show="modelValue" class="fixed top-0 w-full h-full bg-black/50 z-[80] flex justify-center items-center">
        <div class="border rounded-lg shadow shadow-gray-100 bg-white w-[440px] px-6 py-5 flex flex-col gap-6">
            <slot/>
            <div class="flex justify-center items-center gap-2">
                <designButton
                    class="w-full"
                    btnText="Close"
                    btnSize="MD"
                    btnType="QUATERNARY"
                    :btnDisabled="false"
                    @click-event="hidePopup"
                />
                <designButton
                    class="w-full"
                    :btnText="buttonText || 'Confirm'"
                    btnSize="MD"
                    btnType="RED_SOLID"
                    :btnDisabled="false"
                    @click-event="buttonEvent"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import designButton from './design-system/design-button.vue';

defineProps({
    modelValue: Boolean,
    buttonText: String,
    disabled: Boolean,
    hideTitle: Boolean,
    title: String,
    noneOverflowAuto: { type: Boolean, default: false },
    width800: { type: Boolean, default: false },
    maxHeight: { type: String, default: '70vh' },
    minWidth: { type: String, default: '600px' },
    height: { type: String, default: '20rem' },
    width: { type: String, default: '40.25rem' },
    viewCancel : { type : Boolean, default : true },
    titleCenter : { type : Boolean, default : true },
});

const emit = defineEmits(['update:modelValue', 'buttonEvent', 'afterClose']);

function hidePopup() {
    emit('update:modelValue', false);
    emit('afterClose');
}

function buttonEvent() {
    emit('buttonEvent');
}
</script>